import type { JSONContent } from '@tiptap/core';
import { v4 as uuid } from 'uuid';
import { ContentBlock, ContentBlockType, SolverBlock } from '../../model';
import { SolverSlide } from '../../solver';
import { BlockToTiptapConverter } from '../blocks-to-tiptap.converter';

export const convertSolverBlockToTiptap = ((block) => {
  return {
    type: 'solver',
    attrs: {
      ...(block.name && { name: block.name }),
      ...(block.content && { content: block.content }),
      slides: block.slides,
    },
  };
}) satisfies BlockToTiptapConverter<SolverBlock>;

export function convertTiptapToSolverBlock(json: JSONContent): SolverBlock {
  const attrs = json.attrs ?? {};

  return {
    id: uuid(),
    type: ContentBlockType.Solver,
    slides: (attrs['slides'] as SolverSlide[]) ?? [],
    ...(attrs['name'] && { name: attrs['name'] as string }),
    ...(attrs['content'] && { content: attrs['content'] as ContentBlock[] }),
  };
}
